import { z } from "zod";
import { NpdCalculationState } from "../npd-calculation-state";
export const npdWaitingCalculationStatusDtoSchema = z.object({
    state: z.literal(NpdCalculationState.Waiting),
});
